module.exports = __webpack_public_path__ + "img/website-sentosa.80597ffa.svg";